import React from 'react';

import { PrimaryButton, SecondaryButton } from '@components/Button/variants';
import LazyImgixImage from '@components/LazyImgixImage';
import useEventTracking from '@hooks/useEventTracking';
import { ClickTarget, click } from '@tracking';
import { MEDIA_KIT_URL } from '@utils/constants';
import { getImgixSrc } from '@utils/images';
import { scrollPageToTop } from '@utils/scroll';

const PartnersMediaKitSection = (): JSX.Element => {
  const { trackEvent } = useEventTracking();

  const handleMediaKitClickEvent = () => {
    trackEvent(click({ clickTarget: ClickTarget.MediaKit }));
  };

  const handleScrollToTopClickEvent = () => {
    trackEvent(click({ clickTarget: ClickTarget.ScrollToTop }));
  };

  return (
    <article className="mt-48 flex flex-col justify-center border-0 border-t border-solid border-grayscale-beige pt-48 sm:mx-28 sm:mt-64 sm:flex-row sm:gap-x-64 sm:border-b sm:py-24 md:py-32 md:pr-80 lg:mx-0 lg:mt-80 lg:pl-0 lg:pr-28">
      <div className="w-full px-16 sm:order-2 sm:flex sm:max-w-[260px] sm:flex-col sm:justify-center sm:px-0">
        <SecondaryButton
          as="link"
          fullWidth={true}
          href={MEDIA_KIT_URL}
          onClickCapture={handleMediaKitClickEvent}
          target="_blank"
        >
          View media kit
        </SecondaryButton>
        <PrimaryButton
          as="button"
          className="mt-16 sm:mt-24"
          fullWidth={true}
          onClick={scrollPageToTop}
          onClickCapture={handleScrollToTopClickEvent}
        >
          Connect with our team
        </PrimaryButton>
      </div>
      <LazyImgixImage
        className="aspect-[1.84/1] w-full"
        role="presentation"
        sizes="(min-width: 992px) 512px, (min-width: 768px) 312px, (min-width: 480px) 768px, 480px"
        src={getImgixSrc({
          path: 'partners/brand-partnerships-typing-on-laptop-with-logo.jpg',
          isEnvDependent: false,
        })}
        wrapperClassName="!block leading-[0] flex-shrink-0 mt-32 sm:mt-0 mx-auto sm:max-w-[312px] md:max-w-[512px] sm:order-1 sm:rounded-20 overflow-hidden sm:mx-0"
      />
    </article>
  );
};

export default PartnersMediaKitSection;
